import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/Layout/index.vue')

  },
  // {
  //   path: '/404',
  //   component: () => import('@/views/404.vue'),
  //   hidden: true
  // }
  { path: '*', redirect: '/404', hidden: true,component: () => import('@/views/404.vue') }

]

const router = new VueRouter({
  routes
})

export default router
